<template>
  <div class="hello" style="background-color: #E8E8E8; min-height: 100vh;">
    <div style="padding: 10px 10px;">
      <!-- <div style="background-color: #fff; margin-top: 10px; padding: 10px 16px;border-radius: 4px;">
        <van-row type="flex" justify="space-between">
          <van-col span="10">
            <div span="10" style="font-size: 16px; font-weight: 600;color: #000;text-align:left;">区领导</div>
            <div span="10" style="font-size: 12px; font-weight: 200;color: #000;text-align:left; padding: 10px 0px;">区领导</div>
          </van-col>
          <van-col span="10" style="text-align:right;">
            <van-image
              width="60px"
              height="60px"
              fit="cover"
              radius="50%"
              :src="personPic"
            />
          </van-col>
        </van-row>
      </div> -->
      <div
        style="background-color: #fff; margin-top: 10px; padding: 10px 0px;border-radius: 4px;"
      >
        <van-tabs v-model="active" color="#58AAFF">
          <van-tab title="我的项目">
            <van-list v-model="loading" :finished="finished" finished-text="">
              <van-cell
                @click="clickMethod1(item)"
                v-for="item in myproject"
                :key="item.projectId"
                :title="item.name"
              />
            </van-list>
          </van-tab>
          <van-tab title="我的收藏">
            <van-list v-model="loading" :finished="finished" finished-text="">
              <van-cell
                @click="clickMethod(item)"
                v-for="item in myfocusproject"
                :key="item.projectId"
                :title="item.name"
              />
            </van-list>
          </van-tab>
          <van-tab title="我的批示">
            <van-list v-model="loading" :finished="finished" finished-text="">
              <van-cell
                @click="clickMethod1(item)"
                v-for="item in mypsproject"
                :key="item.projectId"
                :title="item.name"
              />
            </van-list>
          </van-tab>
        </van-tabs>
      </div>
      <div style="height: 100px;"></div>
      <div class="anMen" @click="openVconsole"></div>
    </div>
  </div>
</template>

<script>
import zdqdUser from '../api/zdqd'
import crudUser from '../api/user'
import { addBaseAplus } from '../utils/baseAplus'
import dd from 'gdt-jsapi'
export default {
  name: 'Zdqd',
  data() {
    return {
      value: '',
      active: 0,
      activeNames: '',
      personPic: require('../assets/picture/person.png'),
      list: [
        '文旅体融合突破',
        '腾笼换鸟基础再造工程',
        '科技赋能行动',
        '宁波亚洲浆纸业有限公司绿色环保卡纸及配套项目',
        '东华能源烷烃资源综合利用四期项目',
        '加强数字自贸区建设'
      ],
      loading: false,
      finished: true,
      myfocusproject: [],
      mypsproject: [],
      myproject: [],
      VconsoleClickFlag: 0
    }
  },
  mounted() {},
  created() {
    zdqdUser.getMyFocus().then(res => {
      this.myfocusproject = res.data
    })
    zdqdUser.getMyps().then(res => {
      this.mypsproject = res.data
    })
    zdqdUser.getMyproject().then(res => {
      this.myproject = res.data
    })
  },
  methods: {
    clickMethod(item) {
      this.$router.push({
        //核心语句
        path: '/projectdetail', //跳转的路径
        query: { id: item.projectId }
      })
    },
    clickMethod1(item) {
      if (item.pid == 0) {
        this.$router.push({
          //核心语句
          path: '/projectdetail', //跳转的路径
          query: { id: item.projectId }
        })
      } else if (item.pid == 1) {
        this.$router.push({
          //核心语句
          path: '/projectlist', //跳转的路径
          query: { id: item.projectId }
        })
      }
    },
    openVconsole() {
      this.VconsoleClickFlag = this.VconsoleClickFlag + 1
      if (this.VconsoleClickFlag > 4) {
        alert('')
        localStorage.setItem('OpenVconsole', 'true')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.anMen {
  position: fixed;
  right: 0;
  bottom: 10%;
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserCenter.vue